import React, { useState, useEffect } from "react";
import {Button,Card,Col,DatePicker,Divider,Row,Select,Space,Table,message,} from "antd";
import { DownloadOutlined, SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { BASE_URL } from "../../App";
import { Tooltip } from "antd";
import "./bcs.css";

const { Option } = Select;

const BcsOrderStatus = () => {
  const usertype = localStorage.getItem("usertype");
  const LOGIN_ID = localStorage.getItem("LOGIN_ID");
  const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");

  const [branches, setBranches] = useState([]);
  const [branch, setBranch] = useState(null);
  const [dealers, setDealers] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);

  
  const documentColumns = [
    "wo_tech_data_sheet_path",
    "cust_approved_gad_path",
    "cust_approved_qap_path",
    "drawing_file_path",
    "other_documents_path",
    "technical_data_sheet_path",
  ];

  const columnTitleMap = {
    "wo_tech_data_sheet_path": "WO Tech",
    "cust_approved_gad_path": "Cust Apd",
    "cust_approved_qap_path": "QAP Apd",
    "drawing_file_path": "Drawing",
    "other_documents_path": "Other",
    "technical_data_sheet_path": "Technical Data",
  };

  
  useEffect(() => {
    axios
      .post(`${BASE_URL}/GetbranchforBcs`, { usertype, BRANCH_CODE, LOGIN_ID })
      .then((res) => {
        if (res.data.status_code === 200) setBranches(res.data.branchlist || []);
      })
      .catch((err) => console.error("Error fetching branches", err));
  }, []);

  
  useEffect(() => {
    if (!branch) {
      setDealers([]);
      return;
    }
    axios
      .post(`${BASE_URL}/getdealeroptionsforbcs`, { branch })
      .then((res) => {
        if (res.data.status_code === 200) setDealers(res.data.dealerList || []);
      })
      .catch((err) => console.error("Error fetching dealers", err));
  }, [branch]);

  
  const openDocument = (base64, docNo, index) => {
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(
        `<iframe src="${base64}" frameborder="0" style="width:100%;height:100%;"></iframe>`
      );
      newWindow.document.title = `Document - ${docNo || index}`;
    } else {
      message.error("Unable to open document. Please allow popups for this site.");
    }
  };

  
  const handleView = () => {
    if (!branch) return message.info("Please select a Branch.");
    if (!fromDate) return message.info("Please select a From Date.");
    if (!toDate) return message.info("Please select a To Date.");

    setLoading(true);
    axios
      .post(`${BASE_URL}/getbcsordersreport`, {
        branch,
        fromDate: dayjs(fromDate).format("YYYY-MM-DD"),
        toDate: dayjs(toDate).format("YYYY-MM-DD"),
        usertype:usertype,
        LOGIN_ID:LOGIN_ID,
      })
      .then((res) => {
        if (res.data.status_code === 200 && res.data.data.length > 0) {
          const responseData = res.data.data;

          
          const generatedColumns = Object.keys(responseData[0]).map((key) => {
            
            if (documentColumns.includes(key)) {
              return {
                title: columnTitleMap[key],
                dataIndex: key,
                key: key,
                width: 180,
                render: (base64, record, index) =>
                  base64 ? (
                    <a style={{ cursor: "pointer" }} onClick={() => openDocument(base64, record.Doc_no, index)}>
                      View
                    </a>
                  ) : "-",
              };
            }

            
            if (key.toLowerCase() === "orderstatus" || key.toLowerCase() === "status") {
              return {
                title: key.replace(/_/g, " "),
                dataIndex: key,
                key: key,
                width: 120,
                render: (text) => <span className={`status-badge status-${text.toLowerCase()}`}>{text}</span>,
              };
            }

            
            return {
              title: key.replace(/_/g, " "),
              dataIndex: key,
              key: key,
              width: 300,
              ellipsis: true,
            };
          });

          setColumns(generatedColumns);
          setData(responseData);
        } else {
          setData([]);
          setColumns([]);
          message.info("No records found.");
        }
      })
      .catch((err) => {
        console.error(err);
        message.error("Error fetching report.");
      })
      .finally(() => setLoading(false));
  };

  
  const handleExport = () => {
    if (!data.length) return message.info("No data to export.");
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "BCS Orders");
    XLSX.writeFile(wb, "BCS_Orders_Report.xlsx");
  };

  return (
    <div style={{ padding: "16px", maxWidth: "100%" }}>
      <Card bordered={false} style={{ boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.03)" }}>
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={12} md={6}>
            <Select
              placeholder="Select Branch"
              style={{ width: "100%" }}
              onChange={(value) => setBranch(value)}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            >
              {branches.map((b) => (
                <Option key={b.BRANCH_CODE} value={b.BRANCH_CODE}>
                  {`${b.BRANCH_CODE} - ${b.BRANCH_NAME}`}
                </Option>
              ))}
            </Select>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <DatePicker style={{ width: "100%" }} placeholder="From Date" value={fromDate} onChange={setFromDate} />
          </Col>

          <Col xs={24} sm={12} md={6}>
            <DatePicker style={{ width: "100%" }} placeholder="To Date" value={toDate} onChange={setToDate} />
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Space>
              <Button type="primary" icon={<SearchOutlined />} onClick={handleView} loading={loading}>
                View
              </Button>
              <Button icon={<DownloadOutlined />} onClick={handleExport} disabled={!data.length}>
                Export
              </Button>
            </Space>
          </Col>
        </Row>

        <Divider />

        <div style={{ marginTop: 16 }}>
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            scroll={{ x: true }}
            size="middle"
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (total) => <span style={{ color: "#5F6D7E" }}>Total {total} items</span>,
            }}
            sticky
            className="bcs-table"
            rowKey={(record, index) => index}
          />
        </div>
      </Card>
    </div>
  );
};

export default BcsOrderStatus;
